import {createContext, useContext} from 'react'
import {TabDebug} from 'debug/TabDebug'
import {TabAbout} from './TabAbout'
import {TabSteps} from './TabSteps'
import {TabTutorial} from './TabTutorial'

const showDebugControls = process.env.NODE_ENV !== 'production'

export const TabsContext = createContext({})

export const renderTabs = ({
  products, rawProducts, sendProducts,
  showLookCallback, faceScanResults, recommendedProducts,
}) => {
  const prodTabComponents = {
    'About': () => <TabAbout {...{products}} />,
    'Steps': () => <TabSteps {...{rawProducts, sendProducts}} />,
    'Tools': () => <div></div>,
    'Tutorial': () => <TabTutorial />,
  }
  const debugTabComponents = showDebugControls ? {
    'Debug': () => <TabDebug {...{showLookCallback, faceScanResults, recommendedProducts}} />,
  } : {}
  const tabComponents = {...prodTabComponents, ...debugTabComponents}
  const tabs = Object.keys(tabComponents)

  return {
    Buttons: () => <Buttons {...{tabs, rawProducts, sendProducts}} />,
    Content: () => <Content {...{tabs, tabComponents}} />,
  }
}

const Buttons = ({tabs, rawProducts, sendProducts}) => {
  const {tab, setTab} = useContext(TabsContext)
  return (
    <div className="tabs">
      {tabs.map((name, i) => (
        <button
          className={`tab ${tab === name ? 'active' : ''} size-m`}
          onClick={() => {
            setTab(name)
            if (name === 'About') {
              sendProducts(rawProducts)
            }
          }}
          key={name}
        >
          <div className="tab-text">{name}</div>
        </button>
      ))}
    </div>
  )
}

const Content = ({tabs, tabComponents}) => {
  const {tab} = useContext(TabsContext)
  return tabs.map(it => (
    <div style={tab === it ? {} : {display: 'none'}}>
      {tabComponents[it]()}
    </div>
  ))
}
